import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginTop: '16px' }}>
      <button
        className="admin-btn admin-btn--ghost admin-btn--sm"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <i className="fa-solid fa-chevron-left" style={{ fontSize: '11px' }} />
      </button>
      {start > 1 && (
        <>
          <button className="admin-btn admin-btn--ghost admin-btn--sm" onClick={() => onPageChange(1)}>1</button>
          {start > 2 && <span style={{ color: 'var(--admin-text-muted)', fontSize: '12px', padding: '0 4px' }}>...</span>}
        </>
      )}
      {pages.map(p => (
        <button
          key={p}
          className={`admin-btn admin-btn--sm ${p === currentPage ? 'admin-btn--primary' : 'admin-btn--ghost'}`}
          onClick={() => onPageChange(p)}
        >
          {p}
        </button>
      ))}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span style={{ color: 'var(--admin-text-muted)', fontSize: '12px', padding: '0 4px' }}>...</span>}
          <button className="admin-btn admin-btn--ghost admin-btn--sm" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
        </>
      )}
      <button
        className="admin-btn admin-btn--ghost admin-btn--sm"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <i className="fa-solid fa-chevron-right" style={{ fontSize: '11px' }} />
      </button>
    </div>
  );
}

export default Pagination;
